<template>
    <transition
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="opened"
            class="sticky top-0 z-40 flex items-center gap-3 border-b border-new-amber-200 bg-new-amber-50 px-4 py-3 mt-3"
        >
            <TriangleAlert class="size-5 shrink-0 text-new-amber-600" />

            <div class="flex-1 text-sm">
                <template v-if="type === 'pro-team' || type === 'pro-personal'">
                    <span class="font-medium text-new-amber-900">
                        You are on the Free plan.
                    </span>
                    <span class="text-new-amber-700">
                        Subscribe to continue using
                        {{ type === 'pro-personal' ? 'TOPOL Pro' : 'TOPOL Team' }}
                        with all features.
                    </span>
                </template>
                <template v-if="type === 'plugin'">
                    <span class="font-medium text-new-amber-900">
                        Your Plugin API Tokens are suspended.
                    </span>
                    <span class="text-new-amber-700">
                        Select a Plugin subscription to continue.
                    </span>
                </template>
                <template v-if="type === 'old-app-pro'">
                    <span class="font-medium text-new-amber-900">
                        Your prepaid plan is outdated.
                    </span>
                    <span class="text-new-amber-700">
                        Team subscriptions are now paid individually. Update your subscription before it expires.
                    </span>
                </template>
            </div>

            <div class="flex items-center gap-2 shrink-0">
                <a
                    v-if="type === 'old-app-pro'"
                    href="https://support.topol.io/en/articles/6622160-switching-to-the-new-billing-plan"
                    target="_blank"
                >
                    <Button variant="outline" size="sm">
                        Learn more
                    </Button>
                </a>
                <Button size="sm" @click="handleSubscribe">
                    Subscribe now
                </Button>
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from 'ziggy-js'
import { TriangleAlert } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

const props = defineProps<{
    type: 'pro-personal' | 'pro-team' | 'plugin' | 'old-app-pro'
}>()

const opened = ref(true)

const handleSubscribe = () => {
    if (props.type === 'plugin') {
        router.visit(route('billing.plugin-subscriptions.index'))
    } else {
        router.visit(route('billing.pro-subscriptions.index'))
    }
}
</script>
